module.exports = __webpack_public_path__ + "4279aabf6bd2e738498988419fe2e67e.svg";